import { useState } from 'react';
import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import EditorPageLayout from '../../components/layouts/editor-page/editor-page-layout';
import { RichTextEditor } from '../../components/rich-text-editor/rich-text-editor';
import FontBody2 from '../../components/fonts/font-body2/font-body2';
import { Button } from '../../components/inputs/button/button';
import ListLayout from '../../components/layouts/list-layout/list-layout';


const RichEditorPage: React.FC = () => {
    const [value, setValue] = useState<string|undefined|null>('<b>Hello</b>');
    const [disabled, setDisable] = useState<boolean>(true);

    const onChange = (v: string) => {
        setValue(v);
        console.log('onChange called');
    };

    return (
        <BasePageLayout title="Rich Editor Test">
            <EditorPageLayout
                toolbar={{
                    hasLocalesSelector: false
                }}>

                <ListLayout>
            
                    <RichTextEditor onChange={onChange} value={value} disabled={disabled} />

                    <FontBody2>
                        <div dangerouslySetInnerHTML={{ __html:value as string }}></div>
                    </FontBody2>

                    <code style={{ fontSize: '10px' }}>{value}</code>                

                    
                    <Button text="toggle editor" onClick={() => setDisable(!disabled)} />

                </ListLayout>

            </EditorPageLayout>
        </BasePageLayout>
    );
}

export default RichEditorPage;
